import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { IServiceFrequency } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.frequency}`

export const getServiceFrequencies = createAsyncThunk<
  IServiceFrequency[],
  void,
  { rejectValue: APIError }
>('services/frequency', async (_, thunkApi) => {
  const response = await get(`${baseUrl}`)

  if (response.ok) {
    const payload: ISearchResponse<IServiceFrequency> = await response.json()
    return payload.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
